import { DirectionalStyleSheetBehavior, disabledCursor, display, focusVisible, forcedColorsStylesheetBehavior, } from "@microsoft/fast-foundation";
import { accentForegroundRestBehavior, elevation, neutralFillStealthHoverBehavior, neutralFocusBehavior, neutralForegroundHintBehavior, neutralForegroundRestBehavior, neutralLayerFloatingBehavior, } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
import { SystemColors } from "@microsoft/fast-web-utilities";
import { darkModeStylesheetBehavior } from "../utilities/behaviors";
const SearchBoxLTRStyles = css `
    fluent-button {
        border-radius: 0 var(--search-box-radius) var(--search-box-radius) 0;
    }

    :host(:not([disabled])) .root:focus-within::after {
        border-radius: var(--search-box-radius) 0 0 var(--search-box-radius);
    }

    :host(:focus-within:not([disabled])) fluent-button::after,
    :host([isonimage]:focus-within:not([disabled])) fluent-button::after {
        border-radius: 0 var(--search-box-radius) var(--search-box-radius) 0;
    }

    .searchoptions {
        right: 70px;
    }
`;
const SearchBoxRTLStyles = css `
    fluent-button {
        border-radius: var(--search-box-radius) 0 0 var(--search-box-radius);
    }

    :host(:not([disabled])) .root:focus-within::after {
        border-radius: 0 var(--search-box-radius) var(--search-box-radius) 0;
    }

    :host(:focus-within:not([disabled])) fluent-button::after,
    :host([isonimage]:focus-within:not([disabled])) fluent-button::after {
        border-radius: var(--search-box-radius) 0 0 var(--search-box-radius);
    }

    .searchoptions {
        left: 70px;
    }
`;
export const SearchBoxStyles = css `
    ${display("inline-flex")} :host {
        --search-box-radius: calc(var(--corner-radius) * 2px);
        font-family: var(--body-font);
        outline: none;
        user-select: none;
        --elevation: 4;
        border-radius: var(--search-box-radius);
        transition: all 0.2s ease-in-out;
        position: relative;
        background: ${neutralLayerFloatingBehavior.var};
        ${elevation}
    }

    .root {
        box-sizing: border-box;
        position: relative;
        display: flex;
        flex-direction: row;
        color: ${neutralForegroundHintBehavior.var};        
        border-radius: var(--search-box-radius) 0 0 var(--search-box-radius);
    }

    .control {
        -webkit-appearance: none;
        background: transparent;
        border: 0;
        margin-top: auto;
        margin-bottom: auto; 
        border: none;
        padding: calc(var(--design-unit) * 2px + 2px) 12px;
        color: ${neutralForegroundRestBehavior.var};
        ${ /* hardcoded font-size and font-weight to match Anaheim in Prod */""}
        font-size: 15px;
        font-weight: 400;
        line-height: var(--type-ramp-plus-1-line-height);
        width: 100%;
        z-index: 1;
    }

    .searchoptions {
        position: absolute;
        z-index: 900;
    }

    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration { display: none; }

    .control:hover,
    .control:${focusVisible},
    .control:disabled,
    .control:active {
        outline: none;
    }

    .before-content,
    .after-content {
        ${
/* Glyph size and margin-left is temporary -
replace when adaptive typography is figured out */ ""} width: 16px;
        height: 16px;
        margin: auto;
        fill: ${neutralForegroundRestBehavior.var};
    }

    .end-slot {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    fluent-button {
        height: auto;
        position: relative;
    }

    fluent-button.stealth {
        background: transparent;
    }

    fluent-button.stealth:hover {
        background: ${neutralFillStealthHoverBehavior.var}
    }

    fluent-button::part(control) {
        padding-right: 24px !important;
        padding-left: 24px !important;
    }
    
    :host(:hover:not([disabled])) {
        --elevation: 6;
        ${elevation}
    }

    :host(:not([disabled])) .root:focus-within::after,
    :host(:focus-within:not([disabled])) fluent-button::after,
    :host([isonimage]:focus-within:not([disabled])) fluent-button::after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
    }

    :host([isonimage]) .end-slot slot[name="end"] > svg {
        fill: ${accentForegroundRestBehavior.var};
    }

    :host([isonimage]) fluent-button.stealth:hover {
        background: transparent;
    }

    :host(:not([disabled])) .root:focus-within::after {
        border-right: 0;
    }

    :host(:focus-within:not([disabled])) fluent-button::after,
	:host([isonimage]:focus-within:not([disabled])) fluent-button::after	{
        border-left: 0;
    }

    :host(:focus-within:not([disabled])) fluent-button:focus::after {
        content: unset;
    }

    :host([disabled]) .label,
    :host([readOnly]) .label,
    :host([readOnly]) .control,
    :host([disabled]) .control {
        cursor: ${disabledCursor};
    }

    :host([disabled]) {
        opacity: var(--disabled-opacity);
    }

    :host([disabled]) fluent-button {
        pointer-events: none;
    }
`.withBehaviors(new DirectionalStyleSheetBehavior(SearchBoxLTRStyles, SearchBoxRTLStyles), neutralForegroundHintBehavior, neutralFocusBehavior, neutralForegroundRestBehavior, neutralFillStealthHoverBehavior, neutralForegroundHintBehavior, neutralLayerFloatingBehavior, darkModeStylesheetBehavior(css `
            :host([isonimage]) .end-slot slot[name="end"] > svg {
                fill: ${neutralForegroundRestBehavior.var};
            }
        `), forcedColorsStylesheetBehavior(css `
            :host {
                forced-color-adjust: none;
                background: ${SystemColors.Field};
                box-shadow: ${SystemColors.FieldText} 0px 0px 0px 1px;
            }

            :host(:hover:not([disabled])) {
                box-shadow: ${SystemColors.Highlight} 0px 0px 0px 1px;
            }

            :host([isonimage]) .end-slot slot[name="end"] > svg {
                fill: ${SystemColors.ButtonText};
            }

            :host([isonimage]) fluent-button.stealth:hover svg {
                fill: ${SystemColors.HighlightText};
            }

            :host([disabled]) {
                box-shadow: ${SystemColors.GrayText} 0px 0px 0px 1px;
                opacity: 1;
            }

            :host([disabled]) .label {
                color: ${SystemColors.GrayText};
            }

            :host([disabled]) fluent-button::part(control) {
                background: ${SystemColors.ButtonFace};
                color: ${SystemColors.GrayText};
                fill: currentColor;
            }
        `));
